import{useSelector}from'react-redux';const useIsInEditMode=()=>{return useSelector(state=>state.editMode.isInEditMode);};export default useIsInEditMode;